import React from 'react';
import { useSelector } from 'react-redux';
import { seoStateSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import AboutCity from '@stencil/commonstories/src/components/Seo/about-city/about-city';
import insertAnElementIntoArrayAtSpecificIndex from '@stencil/flights-utils/src/insert-an-element-into-array-at-specific-index';
import FlightFares from '@stencil/commonstories/src/components/Seo/flights-to-flights-from/flight-fares/flight-fares';
import AllFlightsCity from '@stencil/commonstories/src/components/Seo/flights-to-flights-from/all-flights-to-city-from-city/all-flights-to-city-from-city';
import TopHotels from '@stencil/commonstories/src/components/Seo/flights-to-flights-from/top-hotels/top-hotels';
import getListWithNewTitle from '@stencil/flights-utils/src/get-list-with-new-title';
import { FLIGHTS_TEXT, TO } from '@stencil/flights-constants/src/text';

const SeoFlightsToFlightsFromRight = props => {
  const seoState = useSelector(seoStateSelector);
  const {
    source,
    destination,
    hotels,
    attractions,
    allFlightsToCities,
    write_up,
    queryType,
    language,
    h_1_header,
    extraContent,
    extraContentPosition,
    flightFares
  } = seoState;
  const isFlightsTo = queryType && queryType.includes('flights-to') ? true : false;
  const city = isFlightsTo ? destination : source;
  const { name, city_hotels_link, tguide_link, hindi_name } = city;
  const cityName = language === 'hindi' && hindi_name ? hindi_name : name;
  let routeInfoElements = [
    <AllFlightsCity
      allFlightCityLinks={getListWithNewTitle(
        allFlightsToCities,
        !isFlightsTo
          ? `${cityName} ${TO[language]} %s ${FLIGHTS_TEXT[language]}`
          : `%s ${TO[language]} ${cityName} ${FLIGHTS_TEXT[language]}`
      )}
      headerTitle={`All Flights ${isFlightsTo ? 'To' : 'From'} ${cityName}`}
      isDweb={true}
    />,
    ...(hotels && hotels.length > 0
      ? [
          <TopHotels
            hotelsAttractions={hotels.slice(0, 6)}
            type="hotels"
            headerTitle={`Top Hotels in ${cityName}`}
            viewTitle={`+ View All Hotels in ${cityName}`}
            link={city_hotels_link}
            isDweb={true}
          />
        ]
      : []),
    ...(attractions && attractions.length > 0
      ? [
          <TopHotels
            hotelsAttractions={attractions}
            type="attractions"
            headerTitle={`Attractions in ${cityName}`}
            viewTitle={`View ${cityName} Travel Guide`}
            link={`https://goibibo.com${tguide_link}`}
            isDweb={true}
          />
        ]
      : [])
  ];
  routeInfoElements = extraContent
    ? insertAnElementIntoArrayAtSpecificIndex(
        routeInfoElements,
        extraContentPosition,
        <AboutCity title="" longDesc={extraContent} isDweb={true} />
      )
    : routeInfoElements;

  return (
    <>
      <AboutCity title={h_1_header} longDesc={write_up} isDweb={true} shouldBeH1={true} />
      {flightFares && flightFares.length > 0 ? (
        <FlightFares flightFares={flightFares} isDweb={true} />
      ) : null}
      {routeInfoElements.map((element, index) => {
        return <div key={index}>{element}</div>;
      })}
    </>
  );
};

export default SeoFlightsToFlightsFromRight;
